import React from "react";

const AppStoreButtons = () => {
  return (
    <div className="mt-8 flex items-center justify-center gap-4">
      {/* App Store */}
      <a
        href="https://www.apple.com/app-store/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Nizam HR from App Store"
      >
        <img
          src="/assets/images/appstore.png"
          className="h-10"
          alt="app store"
        />
      </a>

      {/* Google Play */}
      <a
        href="https://play.google.com/store"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Nizam HR from Google Play"
      >
        <img
          src="/assets/images/googleplay.png"
          className="h-10"
          alt="google play"
        />
      </a>
    </div>
  );
};

export default AppStoreButtons;
